import { ThunderboltOutlined, ShoppingCartOutlined, GiftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Container from '../Container/Container';
import classes from './FeaturesBar.module.scss';

const FeaturesBar = () => {
  const { t } = useTranslation();

  const items = [
    { icon: <ThunderboltOutlined />, label: t('pages.main.features.instantDelivery') },
    { icon: <ShoppingCartOutlined />, label: t('pages.main.features.fastCheckout') },
    { icon: <GiftOutlined />, label: t('pages.main.features.popularProducts') },
  ];

  return (
    <div className={classes.bar}>
      <Container style={{ height: '100%', minHeight: 'unset', padding: 0 }}>
        <div className={classes.inner}>
          {items.map((item, i) => (
            <div key={i} className={classes.item}>
              <span className={classes.icon}>{item.icon}</span>
              <span className={classes.label}>{item.label}</span>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default FeaturesBar;
